import { create } from 'ipfs-http-client';
import { IPFS_HOST } from '../constants';
import environment from '../environment';
import * as buffer from "buffer";
window.Buffer = buffer.Buffer;

const projectId = environment.IPFS_PROJECT_ID;
const projectSecret = environment.IPFS_PROJECT_SECRET;
const auth =
    'Basic ' + Buffer.from(projectId + ':' + projectSecret).toString('base64');

const ipfs = create({ host: IPFS_HOST, port: '5001', protocol: 'https', headers: { authorization: auth } });

export default ipfs;